import { render } from "./Error500.vue?vue&type=template&id=ab33414e"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__